import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

import CountDownTimer from '../util/timer';
import * as BECaller from '../util/apiCaller';

import syncIcon from '../assets/images/sync-info.svg';

const MAX_RETRIES = 10;

export class NextSync extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      noJob: true,
      inProgress: false
    };
  }

  retries = 0;
  timer = { destroy: () => {} };
  timeout;

  componentDidMount() {
    if ((this.props.app === 'jira' || this.props.app === 'azure') && this.props.dashboard && this.props.dashboard._id) {
      this.init();
    }
  }

  componentDidUpdate(prevProps) {
    let prevDashboard = prevProps.dashboard || {};
    if (
      (this.props.app === 'jira' || this.props.app === 'azure') &&
      this.props.dashboard &&
      this.props.dashboard._id &&
      (prevDashboard._id != this.props.dashboard._id || prevProps.lastUpdated != this.props.lastUpdated)
    ) {
      this.init();
    }
  }

  componentWillUnmount() {
    if (this.timer) {
      this.timer.destroy();
      !!this.timeout && clearTimeout(this.timeout);
    }
  }

  init() {
    if (this.timer) {
      this.timer.destroy();
      !!this.timeout && clearTimeout(this.timeout);
    }
    this.retries = 0;
    this.setState({ noJob: false, loading: true });
    this.getNextSyncTime();
  }

  getNextSyncTime() {
    BECaller.api(`dashboards/${this.props.dashboard._id}/nextsync`).then(data => {
      if (data.noJob || data.noMeta) {
        this.setState({ noJob: true });
        return false;
      }

      if (!data.running && !data.nextRunAt && this.retries < MAX_RETRIES) {
        this.retries++;
        this.timeout = setTimeout(() => this.getNextSyncTime(), 10000);
        return false;
      }

      if (data.running) {
        this.setState({ loading: false, inProgress: true });
        this.timeout = setTimeout(() => this.getNextSyncTime(), 5000);
      }

      if (!data.running && data.nextRunAt) {
        this.startTimer(moment(data.nextRunAt).diff(moment(), 'seconds'));
        this.setState({ loading: false, inProgress: false });
      }
    });
  }

  startTimer(duration) {
    this.timer = new CountDownTimer(duration);
    this.timer.onTick((min, sec) => {
      this.setState({
        time: `${min < 10 ? `0${min}` : min}:${sec < 10 ? `0${sec}` : sec}`
      });
    });
    this.timer.onExpire(() => {
      this.setState({ inProgress: true });
      this.timeout = setTimeout(() => this.getNextSyncTime(), 1000);
    });
    this.timer.start();
  }

  render() {
    if (this.props.app === 'file' && this.props.lastUpdated) {
      return (
        <OverlayTrigger placement="bottom"
                      overlay={<Tooltip id="tooltip-settings" className='tooltip_dark max-width-200 text-align-left'>The dashboard reflects data from the last file upload.</Tooltip>}>
          <span className='next_sync'>
            <img src={syncIcon} alt="#" />
            <span>Last updated <br/>{moment(this.props.lastUpdated).fromNow()}</span>
          </span>
        </OverlayTrigger>
      )
    }

    if (this.state.noJob && (this.props.app !== 'file' || this.props.app !== 'azure')) {
      if (this.props.dashboard && (this.props.dashboard.lastWebhookReceived || this.props.dashboard.lastSynced || this.props.lastUpdated)) {
        return (
          <OverlayTrigger placement="bottom"
                      overlay={<Tooltip id="tooltip-settings" className='tooltip_dark max-width-200 text-align-left'>The dashboard syncs in real-time via webhooks and updates only when changes occur on your <span className='text-capitalize'>{this.props.app}</span> board.</Tooltip>}>
            <span className='next_sync'>
              <img src={syncIcon} alt="#" />
              <span>Last update detected <br/>{moment(Math.max(+new Date(this.props.dashboard.lastWebhookReceived || 0), +new Date(this.props.dashboard.lastSynced || 0), +new Date(this.props.lastUpdated || 0))).fromNow()}</span>
            </span>
          </OverlayTrigger>
        )
      }
    }

    if (this.state.loading || (this.props.app !== 'jira' && this.props.app !== 'azure')) {
      return <span className='next_sync none'></span>;
    }

    return !this.state.inProgress ? (
      <OverlayTrigger placement="bottom"
                      overlay={<Tooltip id="tooltip-settings" className='tooltip_dark max-width-200 text-align-left'>The dashboard pulls changes from your <span className='text-capitalize'>{this.props.app}</span> board every 30 minutes.</Tooltip>}>
        <span className='next_sync'>
          <img src={syncIcon} alt="#" />
          <span>
            Next update in <br/>{this.state.time} min</span>
        </span>
      </OverlayTrigger>
    ) : (
      <span className='next_sync'>
        <img src={syncIcon} alt="#" />
        <span>
          Syncing in progress...
        </span>
      </span>
    );
  }
}

function mapStateToProps(state) {
  return {
    app: state.app.app,
    lastUpdated: state.app.lastUpdated,
    dashboard: state.dashboards.selected
  };
}

export default connect(mapStateToProps)(NextSync);
